import { deserializeXY } from "../serialization";
import type { XY } from "../xy";
import { MobCorpse } from "./mobCorpse";

export class EngineerCorpse extends MobCorpse {
	static key = "EngineerCorpse";

	override getRepairableMobKey(): string | null {
		return "EngineerRobot";
	}

	static deserialize(data: any): EngineerCorpse {
		const c = new EngineerCorpse(deserializeXY(data.xy));
		c.restoreBaseFields(data);
		return c;
	}
}
